import React, { useEffect } from 'react';
// , { useEffect, useState }
import Layout from '@/common/Layout';
// import { useNavigate } from 'react-router-dom';
import EditCantact from './components/MemberShipDetails';
// import { Form }from 'antd'
// import { useDispatch, useSelector } from 'react-redux';
// import { paymentway, verifyAPI } from './redux/slice';

const index = () => {
  useEffect(() => {
    document.title = 'Membership Plans - Premium Features & Benefits';
  }, []);

  // const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const [loading, setLoading] = useState(false);
  // const [selectedPlan, setSelectedPlan] = useState({
  //   title: '',
  //   price: '',
  //   billingFrequency: ''
  // });

  return (
    <>
      <Layout sider={true} hideHeader={true}>
        <EditCantact
        // onsubmit={onsubmit}
        // setSelectedPlan={setSelectedPlan}
        // selectedPlan={selectedPlan}
        // loading={loading}
        />
      </Layout>
    </>
  );
};

export default index;
